import { ReactComponent as ArrowUpSvg } from '../../assets/icons/arrow-up.svg';

export const ArrowUpIcon: SvgIcon = (props) => {
    return <ArrowUpSvg {...props} />;
};
